import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { AboutWidget as mainModule } from './main';
import * as $ from 'jquery';
import * as Config from './config';

declare var require: any;
require('../sass/pdc-widget-about.sass');

export class AboutWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static group = Config.group;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-about'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId;
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(AboutWidget);
